export default "__VITE_ASSET__781a52c7__"